import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core';
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common';
import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en';

const options = {
  graphs: zxcvbnCommonPackage.adjacencyGraphs,
  dictionary: {
    ...zxcvbnCommonPackage.dictionary,
    ...zxcvbnEnPackage.dictionary,
  },
};

zxcvbnOptions.setOptions(options);

export const evaluatePasswordStrength =
  (matchingPattern: RegExp) => (password: string) => {
    const score = zxcvbn(password).score;

    if (score >= 2 && !password.match(matchingPattern)) {
      return 1;
    }

    return score;
  };
